<template>
    <span v-if="button" :class="getButtonClasses">
        <template v-if="['internalButton', 'externalButton'].indexOf(button.type) !== -1">
            <a
                :href="button.url"
                :target="getTarget"
                rel="noopener"
                v-text="button.label"
                class="button__label"
            />
        </template>
        <template v-else-if="['contentButton', 'bookAppointment', 'bookTicket', 'blockAppointments', 'standGuidance'].indexOf(button.type) !== -1">
            <span
                @click="openModal"
                class="button__label"
            >
                <span class="button__label-text">{{ button.label }}</span>
                <span v-if="button.content.buttonType && button.content.buttonType != 'default'" class="button__label-icon">
                    <svgicon :name="`button-icon_${button.content.buttonType}`" />
                </span>
            </span>

            <portal to="modals">
                <modal-element
                    :class="`modal--type-${button.content.buttonType}`"
                    :content="button.content"
                    :open="showModal"
                    @close="closeModal"
                >
                    <appointment-element
                        v-if="button.type == 'bookAppointment' && button.content.hasOwnProperty('appointment')"
                        slot="component"
                        @close="closeModal"
                        :appointment="button.content.appointment" />

                    <stand-guidance-element
                        v-if="button.type == 'standGuidance' && button.content.hasOwnProperty('standGuidance')"
                        slot="component"
                        @close="closeModal"
                        :stand-guidance="button.content.standGuidance" />

                    <block-appointments-element
                        v-if="button.type == 'blockAppointments' && button.content.hasOwnProperty('appointment')"
                        slot="component"
                        @close="closeModal"
                        :appointment="button.content.appointment" />

                    <participation-element
                        v-if="button.type == 'bookTicket' && button.content.hasOwnProperty('participation')"
                        @close="closeModal"
                        slot="component"
                        :participation="button.content.participation" />
                </modal-element>
            </portal>
        </template>
        <template v-else>
            <span
                @click="handleDefaultClick"
                class="button__label">
                {{ button.label }}
                <slot name="icon" />
            </span>
        </template>
    </span>
</template>

<script>
import ModalElement from '@/components/elements/ModalElement.vue';
import AppointmentElement from '@/components/elements/specials/AppointmentElement.vue';
import StandGuidanceElement from '@/components/elements/specials/StandGuidanceElement.vue';
import ParticipationElement from '@/components/elements/specials/ParticipationElement.vue';
import BlockAppointmentsElement from '@/components/elements/specials/BlockAppointmentsElement.vue';

export default {
    name: 'ButtonElement',
    components: {
        ModalElement,
        AppointmentElement,
        ParticipationElement,
        BlockAppointmentsElement,
        StandGuidanceElement,
    },
    props: {
        button: {
            type: Object,
            required: true
        },
        type: {
            type: String,
            default: 'primary'
        },
        disabled: Boolean,
    },
    computed: {

        getTarget() {
            return this.button.targetBlank ? '_blank' : null;
        },

        getButtonClasses() {

            return {
                'button': true,
                'button--disabled': this.disabled,
                [`button--${this.type}`]: true
            }
        }
    },
    data: () => {
        return {
            showModal: false,
        }
    },
    methods: {
        handleDefaultClick() {
            if (this.disabled) { return; }

            this.$emit('click');
        },

        openModal() {
            if (this.disabled) { return; }

            this.showModal = true;
        },

        closeModal() {
            this.showModal = false;
        }
    }
}
</script>
